import { FC } from 'react';

import Code from '../../../Shared/Code';
import ContentGenerator from '../../../Shared/ContentGenerator';

import { useChatContext } from '../../ChatController/ChatController.context';

import { Content } from '../../../../types/tour';
import { State } from '../../../../types/chat';

export type Props = {
  setComplete: (stepIndex: number, parentIndex: number) => void;
  content: Content;
};

const codeSample = (state: State) => `
const channel = client.channel('messaging', '${state.channelId}', {
  name: "Private Chat About the Kingdom",
  image: "https://bit.ly/2F3KEoM",
  members: ["${state.userId}"],
  session: 8 // custom field, you can add as many as you want
});

await channel.watch();

return channel;
`;

export const Step3: FC<Props> = ({ setComplete, content }) => {
  const { state, setChannel } = useChatContext();

  const run = async () => {
    await setChannel();
    setComplete(3, 2);
  };

  return (
    <ContentGenerator
      content={content}
      code={
        <Code
          language="jsx"
          footer={{ label: 'Create Channel', run, disabled: !!state?.channel }}
        >
          {codeSample(state)}
        </Code>
      }
    />
  );
};
